// Badge tooltip configurations
export const BADGE_TOOLTIPS = {
  default: {
    id: "default-tooltip",
    text: "Used automatically when you start a new project.",
    placement: "bottom",
  },
  systemBuiltIn: {
    id: "system-builtin-tooltip",
    text: "Provided by the system.",
    placement: "bottom",
  },
};

// Helper function to get tooltip configuration
export const getBadgeTooltipConfig = (badgeType) => {
  return BADGE_TOOLTIPS[badgeType];
};
